export default "<div class=\"heading-title\">\n  <h2 class=\"title iq-tw-6\">{{title}}</h2>\n  <div class=\"divider\"></div>\n  <p>{{subtitle}}</p>\n</div>"